module.exports = __webpack_public_path__ + "img/specialty2.df27df0.png";